import { render } from "./Opacity.vue?vue&type=template&id=568b1de7"
import script from "./Opacity.vue?vue&type=script&lang=ts"
export * from "./Opacity.vue?vue&type=script&lang=ts"
script.render = render

export default script